<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Basic-Paragraph__And__Spacing_After">Copyright © 2015</p>
<p class="P_Basic-Paragraph__And__Spacing_After">By Barbara Sillery</p>
<p class="P_Basic-Paragraph__And__Spacing_After">All rights reserved</p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"><span> </span></p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"><span><span class="C_span_char-style-override-10">The word “Pelican” and the depiction of a pelican are</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"><span><span class="C_span_char-style-override-10">trademarks of Pelican Publishing Company, Inc., and are</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"><span><span class="C_span_char-style-override-10">registered in the U.S. Patent and Trademark Office.</span></span></p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Spacing_After"> </p>
<p class="P_Basic-Paragraph_para-style-override-6__And__Centre_Alignment__And__Spacing_After"><span>Library of Congress Cataloging-in-Publication Data</span></p>
<p class="P_Basic-Paragraph__And__Spacing_After">Sillery, Barbara.</p>
<p class="P_Basic-Paragraph__And__Spacing_After">Biloxi memories / by Barbara Sillery.</p>
<p class="P_Basic-Paragraph__And__Spacing_After">pages cm</p>
<p class="P_Basic-Paragraph__And__Spacing_After">ISBN 978-1-4556-2067-8 (pbk. : alk. paper) -- ISBN 978-1-4556-2068-5 (e-book) 1. Biloxi (Miss.)--History. I. Title.</p>
<p class="P_Basic-Paragraph__And__Spacing_After">F349.B5S56 2015</p>
<p class="P_Basic-Paragraph__And__Spacing_After">976.2’13--dc23</p>
<p class="P_Basic-Paragraph__And__Centre_Alignment__And__Spacing_After"><span>2015017176</span></p>
<p class="P_div_frame-2__And__Left_Alignment__And__Spacing_After"> </p>
<p class="P_div_frame-2__And__Left_Alignment__And__Spacing_After"><img alt="" src="image2.jpg" style=" max-width: 100%; max-height: 100%;"/></p>
<p class="P_Basic-Paragraph_para-style-override-9__And__Spacing_After">Printed in Singapore</p>
<p class="P_Basic-Paragraph__And__Spacing_After">Published by Pelican Publishing Company, Inc.</p>
<p class="P_Basic-Paragraph_para-style-override-4__And__Spacing_After">1000 Burmaster Street, Gretna, Louisiana 70053</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?46848a41